import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { CheckCircle, Cancel } from "@material-ui/icons";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<boolean>;
export const AfspraakVereist = (props: AllProps) => {
    const { t: tCommon } = useTranslation('common');
    
    const label = props.label || "Afspraak vereist";
    const displayValue = props.value ? tCommon('yes') : tCommon('no');
    const icon = props.value ? <CheckCircle /> : <Cancel />;
    
    return (<Caption {...props} caption={label} icon={icon}>
        {displayValue}
    </Caption>)
}
